"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedCode = void 0;
const react_1 = __importDefault(require("react"));
const highlight_js_1 = __importDefault(require("highlight.js"));
require("highlight.js/styles/github-gist.css");
class HighlightedCode extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.codeRef = react_1.default.createRef();
    }
    componentDidMount() {
        highlight_js_1.default.highlightBlock(this.codeRef.current);
    }
    render() {
        return (react_1.default.createElement("pre", { className: "box is-white" },
            react_1.default.createElement("code", { className: this.props.language, ref: this.codeRef }, this.props.children)));
    }
}
exports.HighlightedCode = HighlightedCode;
